/*
  Как сформировался долг - страница счёта, открывается надписью «Долг
  сформировался за …» на карточке (решение владельца 05.10.2026).

  Вид - вариант В из трёх HTML-макетов на настоящих данных
  (`Desktop\maket-dolg-po-mesyacam`): итоги отчёта 1С сверху, слева месяцы
  начисления полосами, справа услуги выбранного месяца. Владелец выбрал его и
  попросил поставить внутрь основного интерфейса - поэтому это страница кабинета
  со своим адресом, а не всплывающее окно над карточкой: её можно открыть по
  ссылке и вернуться назад кнопкой браузера.

  Пени - тем же видом, что основной долг (решение владельца 05.10.2026): вторая
  полоса итогов «основной долг + пени = к взысканию», переключатель над месяцами
  и расчёт пеней месяца под его услугами.

  Страница - контейнер: грузит расчёт, помнит выбранный месяц и вид списка.
  Всё, что считает деньги, - на сервере (`services/debt_formation.py`,
  `debtor_cabinet_service.debt_today`); разметка - в `DebtTotals`, `DebtClaim`,
  `DebtMonths`, `DebtMonthDetail`.
*/

import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import { api } from '../api/client.js'
import { Empty, Loading, Notice } from '../components/Common.jsx'
import DebtClaim from '../components/DebtClaim.jsx'
import DebtMonthDetail from '../components/DebtMonthDetail.jsx'
import DebtMonths from '../components/DebtMonths.jsx'
import DebtTotals from '../components/DebtTotals.jsx'

function Header({ accountId, formation }) {
  return (
    <header className="head">
      <div>
        <h1 className="head__title">Как сформировался долг</h1>
        {formation ? (
          <div className="head__note">
            Лицевой счёт № {formation.number} · {formation.address}
          </div>
        ) : null}
      </div>
      <Link to={`/accounts/${accountId}`} className="button button--quiet">
        К карточке счёта
      </Link>
    </header>
  )
}

export default function DebtFormationPage() {
  const { accountId } = useParams()
  const [formation, setFormation] = useState(null)
  const [error, setError] = useState(null)
  const [chosen, setChosen] = useState(null)
  const [mode, setMode] = useState('debt')

  useEffect(() => {
    setFormation(null)
    setError(null)
    api.debtFormation(accountId).then(setFormation).catch(setError)
  }, [accountId])

  if (error || !formation) {
    return (
      <>
        <Header accountId={accountId} formation={null} />
        {error ? <Notice error={error} wide /> : <Loading what="Собираем начисления по счёту" />}
      </>
    )
  }

  /*
    Пока человек ничего не выбрал, справа стоит последний месяц: он самый
    свежий, и с него обычно начинают разговор с должником.
  */
  const months = formation.months
  const shown = months.find((month) => month.period === chosen) ?? months[months.length - 1]
  const penalty = formation.penalty
  const penaltyMonth = penalty?.months.find((month) => month.period === shown?.period) ?? null

  return (
    <>
      <Header accountId={accountId} formation={formation} />
      {months.length === 0 ? (
        <Empty title="Долга по начислениям нет">
          Все загруженные начисления по этому счёту оплачены. Появится новая выгрузка с долгом -
          он будет разложен здесь по месяцам и услугам.
        </Empty>
      ) : (
        <>
          <DebtTotals formation={formation} />
          <DebtClaim
            claim={formation.claim}
            penaltyAsOf={penalty?.as_of}
            notice={formation.penalty_notice}
          />
          <div className="debt-layout">
            <DebtMonths
              formation={formation}
              mode={mode}
              onMode={setMode}
              chosen={shown.period}
              onChoose={setChosen}
            />
            <DebtMonthDetail
              month={shown}
              penaltyMonth={penaltyMonth}
              penaltyNotice={formation.penalty_notice}
            />
          </div>
        </>
      )}
    </>
  )
}
